import styled from 'styled-components';

import { token, spaceMixin } from '@zillow/constellation';

export const StyledContainer = styled.div`
    background-color: ${token('colors.white')};
    border-radius: 5px;
    border: 1px solid ${token('colors.gray300')};
    margin-bottom: ${spaceMixin('xl')};
    margin-top: ${spaceMixin('sm')};
    padding: ${spaceMixin('sm')};
`;
